import { PopoverGroup } from '@headlessui/react';
import Link from 'next/link';
import { Fragment } from 'react';

import { useRouteInfo } from '../../../contexts/route_info_context';

import { GroupItem } from './desktop-items/GroupItem';
import type { NavbarItems } from './types';

interface DesktopNavbarProps {
  items: NavbarItems;
}

export function DesktopNavbar(props: DesktopNavbarProps) {
  const { items } = props;
  const { isNmrium } = useRouteInfo();
  const filteredItems = items.filter(
    (item) => !(item.hideOnNmriumPage && isNmrium),
  );
  const buttonItems = filteredItems.filter((item) => item.type === 'button');

  return (
    <>
      <PopoverGroup className="hidden lg:flex lg:gap-x-12">
        {filteredItems
          .filter((item) => item.type === 'basic')
          .map((item) => {
            if (item.type !== 'basic') return null;
            const isGroup = 'group' in item;

            if (isGroup) {
              return <GroupItem key={item.name} item={item} />;
            }

            return (
              <Link
                key={item.name}
                href={'href' in item ? item.href : '#'}
                target={'blank' in item ? '_blank' : undefined}
                className="text-sm/6 font-semibold text-neutral-900"
              >
                {item.name}
              </Link>
            );
          })}
      </PopoverGroup>

      <div className="hidden lg:flex lg:flex-1 lg:justify-end gap-5">
        {buttonItems.map(
          (item) =>
            'largeAction' in item && (
              <Fragment key={item.name}>
                {item.largeAction(item.name, item.icon)}
              </Fragment>
            ),
        )}
      </div>
    </>
  );
}
